import axios from 'axios';
import * as qs from "query-string"
import { getToken } from '@starberry/myaccount-website-utils'

const baseURL = `${process.env.GATSBY_STRAPI_FORM_URL}`;
const token = getToken() || process.env.GATSBY_STRAPI_FORM_TOKEN;

export const api_form_error = "Form could not submitted!";

const authInstance = axios.create({
  baseURL: baseURL,
  //baseURL: "https://strettons-strapi-dev.q.starberry.com",
  headers: {
    Authorization: `Bearer ${token}`,
    // "Content-Type": "multipart/form-data"
  },
});


export const postFormData = async (formData) => {
  //console.log("apiRes formData", formData);
  const stb_form_url = `/api/gatsby-theme-starberry-lomondgroup/stb-form`;

  try {
    const res = await axios.post(`${stb_form_url}`, formData);

    if (res.statusText === 'OK' || res.status === 200) {
      return {
        success: true,
        ...res.data,
      }
    }
    return { success: false }

  } catch (err) {
    console.error(err);
    return { 
      success: false, 
      message: err.response.data
    }
  }

}


export const postFileData = async (data) => {

  const res = await authInstance.post('upload', data)
  .then((res) => {
    // Success
    if (res.statusText === 'OK' || res.status === 200) {
      return {
        success: true,
        ...res.data,
      }
    }
    return { success: false }
  })
  .catch((error) => {
    // Failed
    if (error.response) {
      return {
        success: false,
        message: error.response.data,
      }
    } else {
      // Service error
    }
  })

  return res;

}

// export const postFormData = async (data) => {

//   const res = await authInstance.post('stb-forms/forms', data)
//   .then((res) => {
//     // Success
//     console.log("apiRes res", res);

//     if (res.statusText === 'OK' || res.status === 200) {
//       return {
//         success: true,
//         ...res.data,
//       }
//     }
//     return { success: false }
//   })
//   .catch((error) => {
//     // Failed
//     if (error.response) {
//       return {
//         success: false,
//         message: error.response.data,
//       }
//     } else {
//       // Service error
//     }
//   })
//   return res;
// }

export const putFormData = async (data,id) => {
  const res = await authInstance.put('stb-forms/forms/'+id, data)
  .then((res) => {
    // Success
    if (res.statusText === 'OK' || res.status === 200) {
      return {
        success: true,
        ...res.data,
      }
    }
    return { success: false }
  })
  .catch((error) => {
    // Failed
    if (error.response) {
      return {
        success: false,
        message: error.response.data,
      }
    } else {
      // Service error
    }
  })
  return res;
}

export const getFormData = async (id) => {
  const res = await authInstance.get('stb-forms/forms/'+id).then((res) => {
    // Success
    if (res.statusText === 'OK' || res.status === 200) {
      return {
        success: true,
        ...res.data,
      }
    }
    return { success: false }
  })
  .catch((error) => {
    // Failed
    if (error.response) {
      return {
        success: false,
        message: error.response.data,
      }
    } else {
      // Service error
    }
  })
  return res;
}
